import { registerComponent } from '@gig/magic-common';
import SweepstakesBuyComponent from './sweepstakes-buy.vue.js';

var SweepstakesBuy = registerComponent(SweepstakesBuyComponent);

export { SweepstakesBuy };
